// Unified Salesforce chat support (handles both authenticated and unauthenticated)
export {
  UnifiedSalesforceChatSupport,
  useSalesforceChatSupport,
  SALESFORCE_CHAT_START,
  SALESFORCE_CHAT_END,
} from "./UnifiedSalesforceChatSupport";

export type {
  SalesforceConfig,
  SalesforceChatSupportContextValue,
  EmbeddedChatService,
} from "./UnifiedSalesforceChatSupport";
